<template>
    <div class="liammin-navigation-content-header">
        <div class="flex items-center h-20 p-6 pb-0">
            <img src="@/assets/logo/logo-text-on-dark.svg" alt="Logo image" class="w-28">
        </div>
    </div>
</template>